'use client'
import Image from 'next/image'
import { Button, Logo } from 'app/components/atoms'
import { useRouter } from 'next/navigation'
import LogoIcon from 'public/icons/white-logo.svg'
import CoverImage from 'public/cover.png'

const Maintenance: React.FC = () => {
  const router = useRouter()

  const onGoToTopPage = () => router.push('https://www.tokyustay.co.jp/')
  return (
    <>
      <div className="absolute w-screen h-screen">
        <Image
          alt=""
          src={CoverImage}
          priority
          fill
          sizes="100vw"
          style={{
            objectFit: 'cover',
          }}
        />
      </div>
      <div className="absolute w-screen h-screen bg-gray-dark bg-opacity-60"></div>
      <div className="overflow-auto w-screen h-screen absolute text-white">
        <div className="h-full w-full flex items-center">
          <div className="max-h-full flex flex-col items-center w-full">
            <div className="flex flex-col items-center py-12 lg:py-20 px-8">
              <div className="">
                <Logo icon={<LogoIcon />} />
              </div>
              <h1 className="pt-16 text-2xl font-medium">
                サーバーメンテナンス実施中
              </h1>
              <h2 className="mt-4 text-lg opacity-60">
                Server maintenance in progress
              </h2>
              <div className="text-base font-medium text-center mt-8 space-y-1">
                <p>
                  サーバーメンテナンス実施中につき、ご迷惑をお掛けして申し訳ございません。
                </p>
                <p>メンテナンス終了までしばらくお待ち下さい。</p>
                <p>お急ぎの方はHPより各店舗へ直接お問い合わせ下さい。</p>
              </div>
              <div className="text-xs font-medium text-center mt-4 space-y-1 opacity-60">
                <p>
                  We apologize for the inconvenience caused during the server
                  maintenance.
                </p>
                <p>Please wait for a while until the maintenance is over.</p>
                <p>
                  If you are in a hurry, please contact each store directly from
                  the HP.
                </p>
              </div>
              <div className="text-xs font-medium text-center mt-4 space-y-1 opacity-60">
                <p>서버 이용에 불편을 드려 죄송합니다</p>
                <p>점검이 완료될 때까지 잠시 기다려 주시기 바랍니다</p>
                <p>
                  급한 경우에는 홈페이지에서 직접 각 점포에 문의하시기 바랍니다
                </p>
              </div>
              <div className="text-xs font-medium text-center mt-4 space-y-1 opacity-60">
                <p>服务器正在维护中，很抱歉给您带来不便。</p>
                <p>系统正在维护，请稍候等待。</p>
                <p>如果您有紧急情况，请直接从主页上联系相关商店。</p>
              </div>
              <div className="text-xs font-medium text-center mt-4 space-y-1 opacity-60">
                <p>服務器正在維護中，很抱歉給您帶來不便。</p>
                <p>系統正在維護中，請耐心等候。</p>
                <p>如果您有緊急情況，請直接從主頁上聯繫相關商店。</p>
              </div>
              <Button
                className="w-full lg:w-[350px] mt-10"
                onClick={onGoToTopPage}
              >
                HPへ戻る
              </Button>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default Maintenance
